const api = "https://api-lp-vantagens.appedidos.com.br/api"



export default api

// https://api-lp-vantagens.appedidos.com.br/api

// http://ec2-34-239-177-237.compute-1.amazonaws.com:8000/api